<!-- @format -->
<template>
	<template v-if="needPageCommon">
		<pc-layout-page-common>
			<iframe
				:id="iframeId"
				ref="refIframe"
				:src="iframeId"
				frameborder="no"
				width="100%"
				height="100%"
				scrolling="auto"
				@load="onLoadIframe"
			/>
		</pc-layout-page-common>
	</template>
	<template v-else>
		<iframe
			:id="iframeId"
			ref="refIframe"
			:src="iframeId"
			frameborder="no"
			width="100%"
			height="100%"
			scrolling="auto"
			@load="onLoadIframe"
		/>
	</template>
</template>
<script setup lang="ts">
	import { getEnvUrlByUrl } from '@power/runtime-vue3';
	import { injectCssToIframeDocument, injectCssToDocument } from '@power/utils';
	import { PcLayoutPageCommon } from '@/layout';

	const route = useRoute();

	const refIframe = ref<HTMLIFrameElement>();

	const needPageCommon = computed(() => route.meta.desc && (route.meta.desc as string).includes('needPageCommon'));

	const iframeId = computed(() => {
		const link = route.meta.link as string;
		const url = getEnvUrlByUrl(decodeURIComponent(link));
		return url;
	});

	const onLoadIframe = () => {
		const cssUrl = getEnvUrlByUrl(`power-front-base/frontend/css/commonstyle.css`);
		injectCssToIframeDocument(document, iframeId.value, cssUrl);
		injectCssToDocument(document, cssUrl);
	};

	watch(
		() => route.meta.link,
		() => {
			const link = route.meta.link as string;
			const url = getEnvUrlByUrl(decodeURIComponent(link));
			refIframe.value?.setAttribute('src', url);
		},
	);
</script>
